import Req from '../../req'
const actions = {
    miniappList: function (store, [pid,cb]) {
        let data = {
            uid: store.rootState.user.uid,
            token: store.rootState.user.owcode,
            pid:pid
        }
        Req.applications.miniappList(data, cb);
    },
    miniappStatus: function (store, [pid, name, status, cb]) {
        let data = {
            uid: store.rootState.user.uid,
            token: store.rootState.user.owcode,
            pid:pid,
            name:name,
            status:status
        }
        Req.applications.miniappStatus(data,cb);
    },
    miniappAgree: function (store, [pid, name,  cb]) {
        let data = {
            uid: store.rootState.user.uid,
            token: store.rootState.user.owcode,
            pid:pid,
            name:name,
        }
        Req.applications.miniappAgree(data,cb);
    },
}
export default {
    namespaced: false,
    actions
}